import type { ChildProtectionInvolvementResponse } from "@lbcrm-api/child-protection/clearances/board/child-protection-clearances.responses";
import { useContext } from "react";
import { AbilityContext } from "src/authentication/context/Can";
import { Action } from "src/casl/Action";
import useSWR from "swr";

export const MY_CHILD_PROTECTION_INVOLVEMENT_KEY = "/profile/child-protection-involvement";

/** A yes or no, so the home screen reads no clearance (`[CLR60B]`) */
export const useMyChildProtectionInvolvement = () => {
    const ability = useContext(AbilityContext);

    // Somebody holding no role would only be refused
    const { data } = useSWR<ChildProtectionInvolvementResponse>(
        ability.can(Action.Read, "ChildProtectionClearance") ? MY_CHILD_PROTECTION_INVOLVEMENT_KEY : null,
    );

    return { involved: data?.involved ?? false };
};
